import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../types";
import { ALL_OPERATOR, DROPDOWN_OPTIONS } from "@/constant/global/global.constant";
import { getOperatorsList, getOperatorsListSuccess } from "../slices/operator.slice";

const getOperator = function(state:RootState) {
    return state.operator;
  };

const getLoactions = function(state:RootState){
    return state?.location
}

const getMarket = function(state:RootState) {
    return state.market;
};

export const getOperatorDetail = createSelector(getOperator,(operator)=> {
    const list = operator?.operators?.data?.map((operator)=>({
        id: operator?.operatorId,
        name: operator?.name,
        sourceId: operator?.sourceId,
        providerId:operator?.provider?.providerId
    }))
    const val = [...list]?.sort((a,b)=>a.name.localeCompare(b.name))
    return [ALL_OPERATOR].concat(val);
});

export const getMarketDetail = createSelector([getMarket, getOperator, getLoactions],(market, operator, location)=>{
    const operatorVal =(id:string) => operator?.operators?.data?.find((operator)=> operator.operatorId === id)
    const locationVal = (id:string) => location?.locations?.data?.find((location)=> location?.locationId === id)
    const marketVal = market?.markets?.data?.map((market)=>({
        ...market,
        operatorName: operatorVal(market?.operatorId)?.name,
        locationName: locationVal(market?.locationId)?.name
    }))
     return {
        ...market,
        markets:{
            ...market.markets,
            data: marketVal
        }
     }
});

export const getOperatorDetailWithPagination = createSelector(getOperator,(operator)=> {
    return operator;
});

export const getOperatorsListDetail = createSelector(getOperator,(reduxStoreData)=> {
    const list = reduxStoreData?.operatorsList?.data ?? [];
    const mappedList = list.map((operator) => ({
        id: operator?.operatorId,
        name: operator?.name,
        sourceId: operator?.sourceId,
    }));
    return [ALL_OPERATOR].concat(mappedList);
});


export const getAllMarketsListDetail = createSelector(getMarket,(reduxStoreData)=>{
     const allMarketsList = reduxStoreData?.marketsList?.data?.map((market)=>({
        id: market?.marketId,
        name: market?.name,
        sourceId: market?.sourceId,
        marketsDropdownDisplayValue: ""
    }))
     return [DROPDOWN_OPTIONS.ALL_MARKET_DROPDOWN_OPTION].concat(allMarketsList)
});

export const getMarketsListErrorDetails = createSelector(getMarket,(market)=>{
    const marketsListErrorData = {
        error: market?.error,
        message: `Markets : ${market?.message}`
    }
return marketsListErrorData
})